import React from 'react'
import { BottomNavigation, BottomNavigationAction, useMediaQuery } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import './Navigation.css'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

const useStyles = makeStyles({
    root: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        zIndex: 1000,
        backgroundColor: '#fff',
        boxShadow: '0px -2px 6px #d2dce6',
        borderRadius: '10px 10px 0px 0px',
        height: '66px',
        padding: '0px 15px',
    },
    labelTop: {
        '& .MuiBottomNavigationAction-wrapper': {
            flexDirection: 'column-reverse',
        },
    },
})

const MobileBottomNavigation = ({ NavigationText = [], TextPosition = 'bottom' }) => {
    const classes = useStyles()
    const [value, setValue] = React.useState(0)
    const isMobile = useMediaQuery('(max-width:767px)', {
        defaultMatches: false, // used on server
        noSsr: true, // disables SSR mismatch warning
    })
    return (
        <>
            {isMobile ? (
                <>
                    <BottomNavigation
                        value={value}
                        onChange={(event, newValue) => {
                            setValue(newValue)
                        }}
                        showLabels
                        className={`${classes.root} mobileNavigationContainer`}
                    >
                        {NavigationText.length > 0 ? (
                            NavigationText.map((data, index) => (
                                <BottomNavigationAction
                                    key={index}
                                    component={NavLink}
                                    to={data.url}
                                    label={data.title}
                                    icon={
                                        data.icon ? (
                                            <span className={`material-${data.type}`}>
                                                {data.icon}
                                            </span>
                                        ) : data.path ? (
                                            <>
                                                <img
                                                    src={
                                                        value === index
                                                            ? data.activePath || data.path
                                                            : data.path
                                                    }
                                                    alt="NavIcon"
                                                    style={{ height: 24 }}
                                                />
                                            </>
                                        ) : (
                                            <span className="material-icons">home</span>
                                        )
                                    }
                                    classes={{
                                        root: TextPosition === 'top' ? classes.labelTop : undefined,
                                    }}
                                />
                            ))
                        ) : (
                            <BottomNavigationAction label="Home" />
                        )}
                    </BottomNavigation>
                </>
            ) : null}
        </>
    )
}

MobileBottomNavigation.propTypes = {
    NavigationText: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
            icon: PropTypes.string,
            type: PropTypes.string,
            image: PropTypes.bool,
            link: PropTypes.string,
        }),
    ),
    TextPosition: PropTypes.oneOf(['top', 'bottom']),
}

export default MobileBottomNavigation
